<h2 mat-dialog-title>Add a brand</h2>

<mat-dialog-content class="dialog-body brand-onboard-body">
	<p class="text-muted small mb-3">
		Creates the brand and its vendor together — and links them — so it shows up here ready for a portal login.
	</p>

	<mat-progress-bar mode="indeterminate" *ngIf="loading" color="accent" class="mb-3"></mat-progress-bar>

	<form [formGroup]="form" id="brand-onboard-form" (ngSubmit)="submit()">

		<!-- Brand -->
		<div class="onboard-section">
			<label class="onboard-label">Brand</label>

			<mat-button-toggle-group *ngIf="unlinkedBrands.length" class="mode-toggle" [value]="form.get('brandMode')?.value"
				(change)="setBrandMode($event.value)">
				<mat-button-toggle value="new">New brand</mat-button-toggle>
				<mat-button-toggle value="existing">Existing unlinked brand</mat-button-toggle>
			</mat-button-toggle-group>

			<mat-form-field appearance="outline" class="full-width mt-2" *ngIf="form.get('brandMode')?.value !== 'existing'">
				<mat-label>Brand name</mat-label>
				<input matInput formControlName="brandName" autocomplete="off" placeholder="e.g. Hyde's Hail Mary" />
			</mat-form-field>

			<mat-form-field appearance="outline" class="full-width mt-2" *ngIf="form.get('brandMode')?.value === 'existing'">
				<mat-label>Brand</mat-label>
				<mat-select formControlName="manufacturerId">
					<mat-option *ngFor="let b of unlinkedBrands" [value]="b.manufacturer_id">{{ b.brand_name }}</mat-option>
				</mat-select>
				<mat-hint>Already created via Matrix Brands, but not yet linked to a vendor.</mat-hint>
			</mat-form-field>
		</div>

		<!-- Vendor -->
		<div class="onboard-section">
			<label class="onboard-label">Vendor</label>

			<mat-button-toggle-group class="mode-toggle" [value]="form.get('vendorMode')?.value" (change)="setVendorMode($event.value)">
				<mat-button-toggle value="new">Create new vendor</mat-button-toggle>
				<mat-button-toggle value="existing">Link existing vendor</mat-button-toggle>
			</mat-button-toggle-group>

			<ng-container *ngIf="form.get('vendorMode')?.value === 'new'">
				<mat-form-field appearance="outline" class="full-width mt-2">
					<mat-label>Vendor name</mat-label>
					<input matInput formControlName="vendorName" autocomplete="off" (input)="onVendorNameEdited()" />
					<mat-hint>Defaults to the brand name.</mat-hint>
				</mat-form-field>

				<mat-expansion-panel class="vendor-advanced">
					<mat-expansion-panel-header>
						<mat-panel-title>Vendor details</mat-panel-title>
						<mat-panel-description>Address, terms, license — optional, edit anytime later</mat-panel-description>
					</mat-expansion-panel-header>

					<mat-form-field appearance="outline" class="full-width">
						<mat-label>Address</mat-label>
						<input matInput formControlName="vendorAddress1" autocomplete="off" />
					</mat-form-field>
					<div class="advanced-row">
						<mat-form-field appearance="outline">
							<mat-label>Currency</mat-label>
							<input matInput formControlName="vendorCurrency" maxlength="3" style="text-transform: uppercase" />
						</mat-form-field>
						<mat-form-field appearance="outline">
							<mat-label>Payment terms</mat-label>
							<input matInput formControlName="vendorTerms" maxlength="4" style="text-transform: uppercase" />
						</mat-form-field>
					</div>
					<mat-form-field appearance="outline" class="full-width">
						<mat-label>Tax / license reference</mat-label>
						<input matInput formControlName="vendorTaxref" autocomplete="off" placeholder="e.g. OCM license #" />
					</mat-form-field>
				</mat-expansion-panel>
			</ng-container>

			<mat-form-field appearance="outline" class="full-width mt-2" *ngIf="form.get('vendorMode')?.value === 'existing'">
				<mat-label>Search vendor</mat-label>
				<input matInput [formControl]="supplierFilter" [matAutocomplete]="supplierAuto" autocomplete="off" placeholder="Name or vendor id" />
				<mat-autocomplete #supplierAuto="matAutocomplete">
					<mat-option *ngFor="let s of filteredSuppliers" [value]="s.suppname + ' (' + s.supplierid + ')'" (onSelectionChange)="selectSupplier(s)">
						{{ s.suppname }} <span class="text-muted">· {{ s.supplierid }}</span>
					</mat-option>
				</mat-autocomplete>
			</mat-form-field>
		</div>
	</form>
</mat-dialog-content>

<mat-dialog-actions align="end">
	<button mat-button type="button" (click)="cancel()">Cancel</button>
	<button mat-raised-button color="accent" type="submit" form="brand-onboard-form" [disabled]="saving || !canSubmit">
		{{ saving ? 'Adding…' : 'Add brand' }}
	</button>
</mat-dialog-actions>
